
import { entityTypesId } from '../backendIds'

export const entityRequiredFields = (entityComponentValues, isChildComponent = false) => {
  const fields = {}
  switch (entityComponentValues?.entityTypeId) {
    case entityTypesId.recurrentEntity:
      recurrentEntityRequiredData(fields)
      break
    case entityTypesId.privateEntity:
      privateEntityRequiredData(fields, isChildComponent, entityComponentValues.dniCif)
      break
    case entityTypesId.businessEntity:
      businessEntityRequiredData(fields, isChildComponent)
      break
    default:
      break
  }
  return fields
}

function businessEntityRequiredData (fields, isChildComponent) {
  fields.entityTypeId = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_TYPE_MANDATORY'
  fields.name = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_REGISTERED_NAME_MANDATORY'
  fields.dniCif = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_DNI_MANDATORY'
  fields.address = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_ADDRESS_MANDATORY'
  fields.representativeDni = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_REPRESENTATIVE_DNI_MANDATORY'
  fields.representativeName = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_REPRESENTATIVE_NAME_MANDATORY'
  fields.representativeSurname1 = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_REPRESENTATIVE_SURNAME1_MANDATORY'
  fields.commercialSocietyTypeId = 'ADMIN.RECURRENT_ENTITIES.VALIDATION.COMMERCIAL_SOCIETY_REQUIRED'
  if (!fields.countryCode) {
    fields.countryCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_COUNTRY_MANDATORY'
  }
  if (!fields.stateCode) {
    fields.stateCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_STATE_MANDATORY'
  }
  if (!fields.cityCode) {
    fields.cityCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_CITY_MANDATORY'
  }
  if (!fields.townCode) {
    fields.townCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_TOWN_MANDATORY'
  }
  if (!fields.colonyCode) {
    fields.colonyCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_COLONY_MANDATORY'
  }
  if (!fields.postalCodeCode) {
    fields.postalCodeCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_CP_MANDATORY'
  }
  if (!isChildComponent) {
    if (!fields.activityBproId) {
      fields.activityBproId = 'DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD'
    }
    if (!fields.constitutionAct) {
      fields.constitutionAct = 'DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD'
    }
    if (!fields.constitutionDate) {
      fields.constitutionDate = 'DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD'
    }
  }
}

function privateEntityRequiredData (fields, isChildComponent, dniCif) {
  fields.entityTypeId = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_TYPE_MANDATORY'
  fields.name = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_NAME_MANDATORY'
  fields.surname1 = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_SURNAME1_MANDATORY'
  fields.dniCif = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_DNI_MANDATORY'
  fields.address = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_ADDRESS_MANDATORY'
  fields.rfc = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_RFC_MANDATORY'
  if (!fields.countryCode) {
    fields.countryCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_COUNTRY_MANDATORY'
  }
  if (!fields.stateCode) {
    fields.stateCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_STATE_MANDATORY'
  }
  if (!fields.cityCode) {
    fields.cityCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_CITY_MANDATORY'
  }
  if (!fields.townCode) {
    fields.townCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_TOWN_MANDATORY'
  }
  if (!fields.colonyCode) {
    fields.colonyCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_COLONY_MANDATORY'
  }
  if (!fields.postalCodeCode) {
    fields.postalCodeCode = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_CP_MANDATORY'
  }
  if (!isChildComponent) {
    if (!fields.activityBproId) {
      fields.activityBproId = 'DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD'
    }
    if (!fields.birthdayDate) {
      fields.birthdayDate = 'DOSSIER_COMPONENTS.VALIDATIONS.MANDATORY_FIELD'
    }
  }
}

function recurrentEntityRequiredData (fields) {
  fields.entitySubTypeId = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_RECURRENT_SUBTYPE_ID_MANDATORY'
  fields.entityId = 'DOSSIER_COMPONENTS.VALIDATIONS.ENTITY_RECURRENT_ID_MANDATORY'
}
